// Archivos arrastrados desde el computador y soltados en la app.

// Mismo criterio que el atributo accept del campo de archivo: extensiones
// (".xlsx"), tipos ("application/pdf") o familias ("image/*"). Vacio, todo sirve.
export function aceptaArchivo(archivo: File, accept: string | undefined): boolean {
  const reglas = (accept ?? '')
    .split(',')
    .map(r => r.trim().toLowerCase())
    .filter(Boolean);
  if (!reglas.length) return true;
  const nombre = archivo.name.toLowerCase();
  const tipo = archivo.type.toLowerCase();
  return reglas.some(r =>
    r.startsWith('.') ? nombre.endsWith(r) : r.endsWith('/*') ? tipo.startsWith(r.slice(0, -1)) : tipo === r,
  );
}

// Lo soltado son archivos (y no texto o un enlace arrastrado dentro de la pagina).
export const traeArchivos = (datos: DataTransfer | null) => !!datos && [...datos.types].includes('Files');

// Las carpetas soltadas se recorren completas y cada archivo lleva su ruta
// ("Carpeta/sub/archivo.pdf") como cuando se elige la carpeta con el boton.
// Las entradas se piden antes de esperar nada: el navegador las borra al
// terminar el evento.
export async function archivosSoltados(datos: DataTransfer, carpetas: boolean): Promise<File[]> {
  if (!carpetas) return [...datos.files];
  const entradas = [...datos.items]
    .filter(i => i.kind === 'file')
    .map(i => ({entrada: i.webkitGetAsEntry(), archivo: i.getAsFile()}));
  const lista: File[] = [];
  for (const {entrada, archivo} of entradas) {
    if (entrada?.isDirectory) await recorrer(entrada as FileSystemDirectoryEntry, lista);
    else if (archivo) lista.push(archivo);
  }
  return lista;
}

async function recorrer(carpeta: FileSystemDirectoryEntry, lista: File[]) {
  const lector = carpeta.createReader();
  // readEntries entrega de a 100: se pide hasta que llegue vacio.
  for (;;) {
    const lote = await new Promise<FileSystemEntry[]>((ok, mal) => lector.readEntries(ok, mal));
    if (!lote.length) return;
    for (const e of lote) {
      if (e.isDirectory) await recorrer(e as FileSystemDirectoryEntry, lista);
      else lista.push(conRuta(await new Promise<File>((ok, mal) => (e as FileSystemFileEntry).file(ok, mal)), e));
    }
  }
}

function conRuta(archivo: File, entrada: FileSystemEntry): File {
  Object.defineProperty(archivo, 'webkitRelativePath', {value: entrada.fullPath.replace(/^\//, '')});
  return archivo;
}

// Un archivo soltado fuera de un campo de carga abriria el archivo en la
// pestaña y sacaria a la persona de la app.
export function evitarAbrirArchivosSoltados() {
  const evitar = (e: DragEvent) => {
    if (traeArchivos(e.dataTransfer)) e.preventDefault();
  };
  window.addEventListener('dragover', evitar);
  window.addEventListener('drop', evitar);
}
